export default function initCore(win) {
  'use strict';

  /**
   * Build the global CWHelpers object
   */
  if (!win.CWHelpers) {
    win.CWHelpers = {};
  }
}
